export default "__VITE_ASSET__CJK$lOQz__"